import { useSearchParams } from "react-router-dom"
import { DateTime } from "luxon"

export enum DateFilterParams {
    START = "start",
    END = "end",
}

type UseInitialDateFiltersReturnType = {
    startDate: DateTime
    endDate: DateTime
}

export const useInitialDateFilters = (
    defaultStartDate?: DateTime,
    defaultEndDate?: DateTime,
): UseInitialDateFiltersReturnType => {
    const [searchParams] = useSearchParams()
    const todayDate = DateTime.now().startOf("day")
    // Get dates from URL or use defaults
    const startParam = searchParams.get(DateFilterParams.START)
    const endParam = searchParams.get(DateFilterParams.END)

    const startDate = startParam ? DateTime.fromISO(startParam) : defaultStartDate || todayDate
    const endDate = endParam ? DateTime.fromISO(endParam) : defaultEndDate || todayDate

    return {
        startDate: startDate.isValid ? startDate : todayDate,
        endDate: endDate.isValid ? endDate : todayDate,
    }
}
